// src/components/AppInitializer.jsx
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { loadUserContext } from '../services/utils/loadUserContext'

const AppInitializer = () => {
	const dispatch = useDispatch()

	useEffect(() => {
		loadUserContext(dispatch)
	}, [dispatch])

	return null
}

export default AppInitializer
